export const API_SOCKET_URL= "wss://seymour-events-api-production.up.railway.app";
export const API_URL = 'https://seymour-events-api-production.up.railway.app';

// export const API_URL = 'http://localhost:8080';
// export const API_SOCKET_URL = 'ws://localhost:8080';

export const STRIPE_API_KEY = 'pk_test_51OuOhSCDUiIAFLBNzzPN2llIiIXFMqSagSW5m3uE49qEpPhcVIesf6QtEnVsj5DJaQmi6tTNgzEI6JTW4fbXEz7Z00M6bc8Sbv';
export const REACT_APP_GOOGLE_CLIENT_ID = '587904854621-g3rut3jqc1234lknggk76umsu0bd3aiq.apps.googleusercontent.com'

// Stable keys are sent to the API and used for keyword generation; labels are display-only.
export const ORGANIZATION_TYPES = [
  { value: "church", label: "Church" },
  { value: "k12_school", label: "School / K-12" },
  { value: "university_college", label: "University / College" },
  { value: "nonprofit", label: "Nonprofit" },
  { value: "government", label: "Government / City Council" },
  { value: "conference", label: "Conference" },
];

//65 languages variants
export const SUPPORTED_LANGUAGES = {
  "af": "Afrikaans",
  "ar": "Arabic — العربية",
  "hy": "Armenian",
  "be": "Belarusian",
  "bn": "Bengali",
  "bs": "Bosnian",
  "bg": "Bulgarian",
  "ca": "Catalan",
  "zh-HK": "Chinese (Cantonese, Hong Kong)",
  "zh-TW": "Chinese (Mandarin, Taiwanese)",
  "zh-Hant": "Chinese (Mandarin, Traditional)",
  "zh": "Chinese (Simplified) — 中文 (简体)",
  "hr": "Croatian",
  "cs": "Czech",
  "da": "Danish",
  "da-DK": "Danish (Denmark)",
  "nl": "Dutch",
  "en": "English",
  "et": "Estonian",
  "fil": "Filipino",
  "fi": "Finnish",
  "nl-BE": "Flemish",
  "fr": "French — Français",
  "fr-CA": "French (Canada)",
  "ka": "Georgian",
  "ka-GE": "Georgian (Georgia)",
  "de": "German — Deutsch",
  "de-CH": "German (Switzerland)",
  "el": "Greek",
  "gu": "Gujarati — ગુજરાતી",
  "gu-IN": "Gujarati (India)",
  "he": "Hebrew — עברית",
  "hi": "Hindi",
  "hu": "Hungarian",
  "is": "Icelandic",
  "id": "Indonesian",
  "it": "Italian",
  "ja": "Japanese — 日本語",
  "kn": "Kannada — ಕನ್ನಡ",
  "ko": "Korean",
  "ko-KR": "Korean (South Korea)",
  "lv": "Latvian",
  "lt": "Lithuanian",
  "mk": "Macedonian — македонски",
  "ms": "Malay",
  "mr": "Marathi",
  "ne": "Nepali — नेपाली",
  "no": "Norwegian",
  "fa": "Persian — فارسی",
  "pl": "Polish",
  "pt": "Portuguese",
  "pt-BR": "Portuguese (Brazil)",
  "pt-PT": "Portuguese (Portugal)",
  "pa": "Punjabi — ਪੰਜਾਬੀ",
  "pa-IN": "Punjabi (India)",
  "ro": "Romanian",
  "ru": "Russian",
  "sr": "Serbian — српски",
  "sk": "Slovak",
  "sl": "Slovenian — slovenščina",
  "es": "Spanish",
  "es-419": "Spanish (Latin America and the Caribbean)",
  "sv": "Swedish",
  "sv-SE": "Swedish (Sweden)",
  "tl": "Tagalog — Tagalog",
  "ta": "Tamil — தமிழ்",
  "te": "Telugu — తెలుగు",
  "th": "Thai",
  "th-TH": "Thai (Thailand)",
  "tr": "Turkish",
  "uk": "Ukrainian",
  "ur": "Urdu — اردو",
  "vi": "Vietnamese — Tiếng Việt",
  "zh-CN": "(Mandarin, PRC)",
  "zh-Hans": "(Mandarin, Simplified)"
};

export function sanitizeKeyword(input) {
  const cleaned = input.trim();

  if (!/[a-zA-Z0-9]/.test(cleaned)) {
    return null;
  }

  return encodeURIComponent(cleaned);
}





